import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4abb5328"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-b-confirmation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "Confirmation", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-header" }, " Your submission was successfully received. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body" }, [
  /*#__PURE__*/_createElementVNode("div", null, "The Trust Coordinator will receive a confirmation email in their inbox shortly."),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("If you have questions, please "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.lawsociety.com.au/contact-us",
      target: "_blank",
      class: "link"
    }, "contact us"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_5))
}